/**
 * Created by linjianxi on 2016/11/17.
 */
export const WEEK_TOP_LIST = 'WEEK_TOP_LIST'



// WEBPACK FOOTER //
// ./src/vuex/modules/ticket/mutation-type.js